<template>
  <div class="main">
    <img class="notice-img" src="@/assets/notion-ic.png" />
    <div class="change-voucher">
      <p class="text-line1">{{ contentsPermissions.deniedMsg }}</p>
      <div class="btn-area" v-if="changeVoucherPermissions.denied">
        <button class="home-btn" :class="{ focused: focusIndex == 1 }" @click="goBack">되돌아가기</button>
      </div>
      <div class="btn-area" v-else>
        <button class="home-btn" :class="{ focused: focusIndex == 1 }" @click="goChangeVoucher">변경하러가기</button>
        <button class="close-btn" :class="{ focused: focusIndex == 2 }" @click="goBack" ref="button">되돌아가기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deepLinkCheck: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isActiveVue: true,
      focusIndex: 1,
      ChangeVoucherCheck: true,
    };
  },
  computed: {
    contentsPermissions() {
      return this.$store.getters.contentsPermission
    },
    changeVoucherPermissions() {
      return this.$store.getters.services
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },
  methods: {
    goChangeVoucher() {
      this.$router.push({
        name: "changeVoucher",
      });
    },
    goBack() {
      if (this.deepLinkCheck) {
        this.goHome()
      } else {
        this.$router.go(-1);
      }

    },
    goHome() {
      this.$router.push({
        name: "home",
        params: {
          t: new Date().getTime()
        }
      });
    }
  },
  created() {
    if(sessionStorage.getItem("deepLink")) {
      sessionStorage.removeItem("deepLink")
    }
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
  watch: {
    keyInput(val) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            if (this.focusIndex === 1) {
               if (this.changeVoucherPermissions.denied) {
                this.goBack()
               } else {
                 this.goChangeVoucher()
               }
            } else {
              this.goBack(val);
            }
            break;
          case "ArrowLeft":
            this.focusIndex = 1
            break;
          case "ArrowRight":
            this.focusIndex = 2
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 310px;
  text-align: center;
}

.notice-img {
  width: 128px;
  height: 128px;
}

.text-line1 {
  font-size: 56px;
  line-height: 1.29;
  color: #eeeeee;
  margin-top: 40px;
  margin-bottom: 30px;
  white-space: pre-wrap;
}

.text-line2 {
  font-size: 40px;
  line-height: 1;
  color: #888888;
}

.btn-area {
  display: flex;
  justify-content: center;
}

button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 40px;
  border: none;
}

.close-btn {
  margin-left: 40px;
}

button.focused {
  border: solid 4px #eeeeee;
}


@media all and (min-width:0px) and (max-width:1280px) {
  .main {
    margin-top: 190px;
  }

  .notice-img {
    width: 64px;
    height: 64px;
  }

  .text-line1 {
    font-size: 32px;
    line-height: 1.5;
    color: #ffffff;
    margin-top: 32px;
    margin-bottom: 24px;
    font-weight: bold;
  }

  .text-line2 {
    font-size: 20px;
    line-height: 1;
    color: #888888;
    font-weight: bold;
  }

  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin-top: 48px;
    border: none;
    font-weight: bold;
  }

  .close-btn {
    margin-left: 20px;
  }

  button.focused {
    border: solid 3px #ffffff;
  }
}
</style>